import Button from 'devextreme-react/button';
import './FormCommonStyle.scss';
import './InitialContactScriptForm.scss';
import { showErrorMessage } from '../../../../utils/messages';
import { useState } from 'react';
import { useSaveInitialContactScriptForm } from '../api/save-initialContactScriptForm';

const InitialContactScriptForm: React.FC<{
    retailOrderID: number,
    retailOrderNumber: string,
    onClosePopup: () => void,
    onCheckboxChange: (checked: boolean) => void,
    onSubmit?: () => void
}> =
    ({ retailOrderID, retailOrderNumber, onClosePopup, onCheckboxChange, onSubmit }) => {
        const [mayISpeakToCheckBox, setMayISpeakTo] = useState(false);
        const [introduceYourselfCheckBox, setintroduceYourself] = useState(false);
        const [confirmCustomerCheckBox, setConfirmCustomer] = useState(false);
        const [lowesSurveyScoreCheckBox, setLowesSurveyScoreCheckBox] = useState(false);
        const [verifyFollowingCheckBox, setverifyFollowingCheckBox] = useState(false);
        const [jobAddressText, setJobAddressText] = useState('');
        const [methodOfCommunicationEmailCheckBox, setMethodOfCommunicationEmailCheckBox] = useState(false);
        const [methodOfCommunicationCallCheckBox, setMethodOfCommunicationCallCheckBox] = useState(false);
        const [methodOfCommunicationTextCheckBox, setMethodOfCommunicationTextCheckBox] = useState(false);
        const [newOrExistingCabinetsCheckBox, setNewOrExistingCabinetsCheckBox] = useState(false);
        const [ifExistingCabinetsCheckBox, setIfExistingCabinetsCheckBox] = useState(false);
        const [whoRemovedText, setWhoRemovedText] = useState('');
        const [ifNewCabinetsCheckBox, setIfNewCabinetsCheckBox] = useState(false);
        const [specialtyCabinetsAndMirrorsCheckBox, setSpecialtyCabinetsAndMirrorsCheckBox] = useState(false);
        const [roomOrLocationCheckBox, setRoomOrLocationCheckBox] = useState(false);
        const [roomOrLocationText, setRoomOrLocationText] = useState('');
        const [colorAndFinishCheckBox, setColorAndFinishCheckBox] = useState(false);
        const [ifNaturalStoneYesCheckBox, setIfNaturalStoneYesCheckBox] = useState(false);
        const [ifNaturalStoneNoCheckBox, setIfNaturalStoneNoCheckBox] = useState(false);
        const [colorOrFinishEdgeText, setColorOrFinishEdgeText] = useState('');
        const [backsplashCheckBox, setBacksplashCheckBox] = useState(false);
        const [backsplashSlabCheckBox, setBacksplashSlabCheckBox] = useState(false);
        const [backsplashCustomerSuppliedCheckBox, setBacksplashCustomerSuppliedCheckBox] = useState(false);
        const [ifSlabThickness3cmCheckBox, setIfSlabThickness3cmCheckBox] = useState(false);
        const [ifSlabThickness2cmCheckBox, setIfSlabThickness2cmCheckBox] = useState(false);
        const [standard4CheckBox, setStandard4CheckBox] = useState(false);
        const [fullHeightCheckBox, setFullHeightCheckBox] = useState(false);
        const [extendedOverhangsCheckBox, setExtendedOverhangsCheckBox] = useState(false);
        const [supportCheckBox, setSupportCheckBox] = useState(false);
        const [customerSuppliedCheckBox, setCustomerSuppliedCheckBox] = useState(false);
        const [installerProvidedCheckBox, setInstallerProvidedCheckBox] = useState(false);
        const [otherText, setOtherText] = useState('');
        const [extendedOverhangsText, setExtendedOverhangsText] = useState('');
        const [makeText, setMakeText] = useState('');
        const [modelText, setModelText] = useState('');
        const [suppliedCheckBox, setSuppliedCheckBox] = useState(false);
        const [sinkInstallerCheckBox, setSinkInstallerCheckBox] = useState(false);
        const [customerCheckBox, setCustomerCheckBox] = useState(false);
        const [undermountCheckBox, setUndermountCheckBox] = useState(false);
        const [dropInCheckBox, setDropInCheckBox] = useState(false);
        const [apronCheckBox, setApronCheckBox] = useState(false);
        const [chipMinimizerYesCheckBox, setChipMinimizerYesCheckBox] = useState(false);
        const [chipMinimizerNoCheckBox, setChipMinimizerNoCheckBox] = useState(false);
        const [customerResponsibilityToRemoveCheckBox, setCustomerResponsibilityToRemoveCheckBox] = useState(false);
        const [faucetMakeCheckBox, setFaucetMakeCheckBox] = useState(false);
        const [numberOfHoles, setNumberOfHoles] = useState(false);
        const [hotOrColdWaterDispenserCheckbox, setHotOrColdWaterDispenserCheckbox] = useState(false);
        const [soapPumpCheckBox, setSoapPumpCheckBox] = useState(false);
        const [glassRinserCheckBox, setGlassRinserCheckBox] = useState(false);
        const [airSwitchCheckBox, setAirSwitchCheckBox] = useState(false);
        const [faucetMakeText, setFaucetMakeText] = useState('');
        const [faucetModelText, setFaucetModelText] = useState('');
        const [numberOfHolesText, setNumberOfHolesText] = useState('');
        const [plumbingDisconnectCheckBox, setPlumbingDisconnectCheckBox] = useState(false);
        const [plumbingDisconnectInstallerCheckBox, setPlumbingDisconnectInstallerCheckBox] = useState(false);
        const [plumbingCustomerCheckBox, setPlumbingCustomerCheckBox] = useState(false);
        const [plumbingReconnectCheckBox, setPlumbingReconnectCheckBox] = useState(false);
        const [plumbingReconnectInstallerCheckBox, setPlumbingReconnectInstallerCheckBox] = useState(false);
        const [plumbingReconnectCustomerCheckBox, setPlumbingReconnectCustomerCheckBox] = useState(false);
        const [freeStandingCheckBox, setFreeStandingCheckBox] = useState(false);
        const [slideInCheckBox, setSlideInCheckBox] = useState(false);
        const [cooktopCheckBox, setCooktopCheckBox] = useState(false);
        const [closingDiscussCustomerCheckBox, setClosingDiscussCustomerCheckBox] = useState(false);
        const [discussCustomerAvailabilityCheckBox, setDiscussCustomerAvailabilityCheckBox] = useState(false);
        const [scheduleProjectCheckBox, setScheduleProjectCheckBox] = useState(false);
        const [lowesSurveyExpectationCheckBox, setLowesSurveyExpectationCheckBox] = useState(false);
        const [provideYourContactCheckBox, setProvideYourContactCheckBox] = useState(false);
        const [emailText, setEmailText] = useState('');
        const [contactNameText, setContactNameText] = useState('');
        const [phoneNumberText, setPhoneNumberText] = useState('');
        const [chipMinimizerCheckBox, setChipMinimizerCheckBox] = useState(false);
        const [plumbingOfferCheckBox, setPlumbingOfferCheckBox] = useState(false);
        const [plumbingConnectionsCheckBox, setPlumbingConnectionsCheckBox] = useState(false);
        const [plumbing1120679CheckBox, setPlumbing1120679CheckBox] = useState(false);
        const [plumbing1120669CheckBox, setPlumbing1120669CheckBox] = useState(false);
        const [granite1120680Checkbox, setGranite1120680Checkbox] = useState(false);
        const [granite1120686Checkbox, setGranite1120686Checkbox] = useState(false);
        const [granite1120685Checkbox, setGranite1120685Checkbox] = useState(false);
        const [granite1120684Checkbox, setGranite1120684Checkbox] = useState(false);
        const [quartz1120670Checkbox, setQuartz1120670Checkbox] = useState(false);
        const [quartz1120676Checkbox, setQuartz1120676Checkbox] = useState(false);
        const [quartz1120675Checkbox, setQuartz1120675Checkbox] = useState(false);
        const [quartz1120674Checkbox, setQuartz1120674Checkbox] = useState(false);
        const [plumbingNotOfferDisconnectCheckBox, setPlumbingNotOfferDisconnectCheckBox] = useState(false);
        const [plumbingNotOfferDisconnectInstallerCheckbox, setPlumbingNotOfferDisconnectInstallerCheckbox] = useState(false);
        const [plumbingNotOfferDisconnectCustomerCheckbox, setPlumbingNotOfferDisconnectCustomerCheckbox] = useState(false);
        const [plumbingNotOfferReconnectCheckBox, setPlumbingNotOfferReconnectCheckBox] = useState(false);
        const [plumbingNotOfferReconnectInstallerCheckbox, setPlumbingNotOfferReconnectInstallerCheckbox] = useState(false);
        const [plumbingNotOfferReconnectCustomerCheckbox, setPlumbingNotOfferReconnectCustomerCheckbox] = useState(false);
        const [appliancesMakeCheckBox, setAppliancesMakeCheckBox] = useState(false);
        const [appliancesMakeText, setAppliancesMakeText] = useState('');
        const [appliancesModelText, setAppliancesModelText] = useState('');
        const [appliancesDropInCheckBox, setAppliancesDropInCheckBox] = useState(false);
        const [granite5YearCheckBox, setGranite5YearCheckBox] = useState(false);
        const [granite10YearCheckBox, setGranite10YearCheckBox] = useState(false);
        const [noteText, setNoteText] = useState('');

        const saveInitialContactScriptForm = useSaveInitialContactScriptForm(
            {
                formObject: {
                    retailOrderID: retailOrderID,
                    retailOrderNo: retailOrderNumber,
                    mayISpeakToCheckBox: mayISpeakToCheckBox,
                    introduceYourselfCheckBox: introduceYourselfCheckBox,
                    confirmCustomerCheckBox: confirmCustomerCheckBox,
                    lowesSurveyScoreCheckBox: lowesSurveyScoreCheckBox,
                    verifyFollowingCheckBox: verifyFollowingCheckBox,
                    jobAddressText: jobAddressText,
                    methodOfCommunicationEmailCheckBox: methodOfCommunicationEmailCheckBox,
                    methodOfCommunicationCallCheckBox: methodOfCommunicationCallCheckBox,
                    methodOfCommunicationTextCheckBox: methodOfCommunicationTextCheckBox,
                    newOrExistingCabinetsCheckBox: newOrExistingCabinetsCheckBox,
                    ifExistingCabinetsCheckBox: ifExistingCabinetsCheckBox,
                    whoRemovedText: whoRemovedText,
                    ifNewCabinetsCheckBox: ifNewCabinetsCheckBox,
                    specialtyCabinetsAndMirrorsCheckBox: specialtyCabinetsAndMirrorsCheckBox,
                    roomOrLocationCheckBox: roomOrLocationCheckBox,
                    roomOrLocationText: roomOrLocationText,
                    colorAndFinishCheckBox: colorAndFinishCheckBox,
                    ifNaturalStoneYesCheckBox: ifNaturalStoneYesCheckBox,
                    ifNaturalStoneNoCheckBox: ifNaturalStoneNoCheckBox,
                    colorOrFinishEdgeText: colorOrFinishEdgeText,
                    backsplashCheckBox: backsplashCheckBox,
                    backsplashSlabCheckBox: backsplashSlabCheckBox,
                    backsplashCustomerSuppliedCheckBox: backsplashCustomerSuppliedCheckBox,
                    ifSlabThickness3cmCheckBox: ifSlabThickness3cmCheckBox,
                    ifSlabThickness2cmCheckBox: ifSlabThickness2cmCheckBox,
                    standard4CheckBox: standard4CheckBox,
                    fullHeightCheckBox: fullHeightCheckBox,
                    extendedOverhangsCheckBox: extendedOverhangsCheckBox,
                    supportCheckBox: supportCheckBox,
                    customerSuppliedCheckBox: customerSuppliedCheckBox,
                    installerProvidedCheckBox: installerProvidedCheckBox,
                    otherText: otherText,
                    extendedOverhangsText: extendedOverhangsText,
                    makeText: makeText,
                    modelText: modelText,
                    suppliedCheckBox: suppliedCheckBox,
                    sinkInstallerCheckBox: sinkInstallerCheckBox,
                    customerCheckBox: customerCheckBox,
                    undermountCheckBox: undermountCheckBox,
                    dropInCheckBox: dropInCheckBox,
                    apronCheckBox: apronCheckBox,
                    chipMinimizerYesCheckBox: chipMinimizerYesCheckBox,
                    chipMinimizerNoCheckBox: chipMinimizerNoCheckBox,
                    customerResponsibilityToRemoveCheckBox: customerResponsibilityToRemoveCheckBox,
                    faucetMakeCheckBox: faucetMakeCheckBox,
                    numberOfHoles: numberOfHoles,
                    hotOrColdWaterDispenserCheckbox: hotOrColdWaterDispenserCheckbox,
                    soapPumpCheckBox: soapPumpCheckBox,
                    glassRinserCheckBox: glassRinserCheckBox,
                    airSwitchCheckBox: airSwitchCheckBox,
                    faucetMakeText: faucetMakeText,
                    faucetModelText: faucetModelText,
                    numberOfHolesText: numberOfHolesText,
                    plumbingDisconnectInstallerCheckBox: plumbingDisconnectInstallerCheckBox,
                    plumbingDisconnectCheckBox: plumbingDisconnectCheckBox,
                    plumbingCustomerCheckBox: plumbingCustomerCheckBox,
                    plumbingReconnectCheckBox: plumbingReconnectCheckBox,
                    plumbingReconnectInstallerCheckBox: plumbingReconnectInstallerCheckBox,
                    plumbingReconnectCustomerCheckBox: plumbingReconnectCustomerCheckBox,
                    freeStandingCheckBox: freeStandingCheckBox,
                    slideInCheckBox: slideInCheckBox,
                    cooktopCheckBox: cooktopCheckBox,
                    closingDiscussCustomerCheckBox: closingDiscussCustomerCheckBox,
                    discussCustomerAvailabilityCheckBox: discussCustomerAvailabilityCheckBox,
                    scheduleProjectCheckBox: scheduleProjectCheckBox,
                    lowesSurveyExpectationCheckBox: lowesSurveyExpectationCheckBox,
                    provideYourContactCheckBox: provideYourContactCheckBox,
                    emailText: emailText,
                    contactNameText: contactNameText,
                    phoneNumberText: phoneNumberText,
                    chipMinimizerCheckBox: chipMinimizerCheckBox,
                    plumbingOfferCheckBox: plumbingOfferCheckBox,
                    plumbingConnectionsCheckBox: plumbingConnectionsCheckBox,
                    plumbing1120679CheckBox: plumbing1120679CheckBox,
                    plumbing1120669CheckBox: plumbing1120669CheckBox,
                    granite1120680Checkbox: granite1120680Checkbox,
                    granite1120686Checkbox: granite1120686Checkbox,
                    granite1120685Checkbox: granite1120685Checkbox,
                    granite1120684Checkbox: granite1120684Checkbox,
                    quartz1120670Checkbox: quartz1120670Checkbox,
                    quartz1120676Checkbox: quartz1120676Checkbox,
                    quartz1120675Checkbox: quartz1120675Checkbox,
                    quartz1120674Checkbox: quartz1120674Checkbox,
                    plumbingNotOfferDisconnectCheckBox: plumbingNotOfferDisconnectCheckBox,
                    plumbingNotOfferDisconnectInstallerCheckbox: plumbingNotOfferDisconnectInstallerCheckbox,
                    plumbingNotOfferDisconnectCustomerCheckbox: plumbingNotOfferDisconnectCustomerCheckbox,
                    plumbingNotOfferReconnectCheckBox: plumbingNotOfferReconnectCheckBox,
                    plumbingNotOfferReconnectInstallerCheckbox: plumbingNotOfferReconnectInstallerCheckbox,
                    plumbingNotOfferReconnectCustomerCheckbox: plumbingNotOfferReconnectCustomerCheckbox,
                    appliancesMakeText: appliancesMakeText,
                    appliancesModelText: appliancesModelText,
                    appliancesMakeCheckBox: appliancesMakeCheckBox,
                    appliancesDropInCheckBox: appliancesDropInCheckBox,
                    granite5YearCheckBox: granite5YearCheckBox,
                    granite10YearCheckBox: granite10YearCheckBox,
                    noteText: noteText
                }
            },
            (result) => {
                onClosePopup();
                onCheckboxChange(true);
                if (onSubmit !== undefined) onSubmit!();
            },
            (error) => showErrorMessage(error)
        );

        const handleJobAddressChange = (event: React.ChangeEvent<HTMLInputElement>) => {
            setJobAddressText(event.target.value);
        };

        const handleWhoRemovedTextChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
            setWhoRemovedText(event.target.value);
        };

        const handleRoomLocationText = (event: React.ChangeEvent<HTMLInputElement>) => {
            setRoomOrLocationText(event.target.value);
        };

        const handleColorOrFinishEdgeText = (event: React.ChangeEvent<HTMLInputElement>) => {
            setColorOrFinishEdgeText(event.target.value);
        };

        const handleOtherText = (event: React.ChangeEvent<HTMLInputElement>) => {
            setOtherText(event.target.value);
        };

        const handleExtendedOverhangsText = (event: React.ChangeEvent<HTMLInputElement>) => {
            setExtendedOverhangsText(event.target.value);
        };

        const handleMakeText = (event: React.ChangeEvent<HTMLInputElement>) => {
            setMakeText(event.target.value);
        };

        const handleModelText = (event: React.ChangeEvent<HTMLInputElement>) => {
            setModelText(event.target.value);
        };

        const handleFaucetMakeText = (event: React.ChangeEvent<HTMLInputElement>) => {
            setFaucetMakeText(event.target.value);
        };

        const handleFaucetModelText = (event: React.ChangeEvent<HTMLInputElement>) => {
            setFaucetModelText(event.target.value);
        };

        const handleNumberOfHolesText = (event: React.ChangeEvent<HTMLInputElement>) => {
            setNumberOfHolesText(event.target.value);
        };

        const handleEmailText = (event: React.ChangeEvent<HTMLInputElement>) => {
            setEmailText(event.target.value);
        };

        const handleContactNameText = (event: React.ChangeEvent<HTMLInputElement>) => {
            setContactNameText(event.target.value);
        };

        const handlePhoneNumberText = (event: React.ChangeEvent<HTMLInputElement>) => {
            setPhoneNumberText(event.target.value);
        };

        const handleAppliancesMakeText = (event: React.ChangeEvent<HTMLInputElement>) => {
            setAppliancesMakeText(event.target.value);
        };

        const handleAppliancesModelText = (event: React.ChangeEvent<HTMLInputElement>) => {
            setAppliancesModelText(event.target.value);
        };

        const handleNoteText = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
            setNoteText(event.target.value);
        };

        const handleReset = () => {
            setMayISpeakTo(false);
            setintroduceYourself(false);
            setConfirmCustomer(false);
            setLowesSurveyScoreCheckBox(false);
            setverifyFollowingCheckBox(false);
            setJobAddressText('');
            setMethodOfCommunicationEmailCheckBox(false);
            setMethodOfCommunicationCallCheckBox(false);
            setMethodOfCommunicationTextCheckBox(false);
            setNewOrExistingCabinetsCheckBox(false);
            setIfExistingCabinetsCheckBox(false);
            setWhoRemovedText('');
            setIfNewCabinetsCheckBox(false);
            setSpecialtyCabinetsAndMirrorsCheckBox(false);
            setRoomOrLocationCheckBox(false);
            setRoomOrLocationText('');
            setColorAndFinishCheckBox(false);
            setIfNaturalStoneYesCheckBox(false);
            setIfNaturalStoneNoCheckBox(false);
            setColorOrFinishEdgeText('');
            setBacksplashSlabCheckBox(false);
            setBacksplashCustomerSuppliedCheckBox(false);
            setIfSlabThickness3cmCheckBox(false);
            setIfSlabThickness2cmCheckBox(false);
            setStandard4CheckBox(false);
            setFullHeightCheckBox(false);
            setExtendedOverhangsCheckBox(false);
            setSupportCheckBox(false);
            setCustomerSuppliedCheckBox(false);
            setInstallerProvidedCheckBox(false);
            setOtherText('');
            setExtendedOverhangsText('');
            setMakeText('');
            setModelText('');
            setSuppliedCheckBox(false);
            setSinkInstallerCheckBox(false);
            setCustomerCheckBox(false);
            setUndermountCheckBox(false);
            setDropInCheckBox(false);
            setApronCheckBox(false);
            setChipMinimizerYesCheckBox(false);
            setChipMinimizerNoCheckBox(false);
            setCustomerResponsibilityToRemoveCheckBox(false);
            setFaucetMakeCheckBox(false);
            setNumberOfHoles(false);
            setHotOrColdWaterDispenserCheckbox(false);
            setSoapPumpCheckBox(false);
            setGlassRinserCheckBox(false);
            setAirSwitchCheckBox(false);
            setFaucetMakeText('');
            setFaucetModelText('');
            setNumberOfHolesText('');
            setPlumbingDisconnectInstallerCheckBox(false);
            setPlumbingCustomerCheckBox(false);
            setPlumbingReconnectInstallerCheckBox(false);
            setPlumbingReconnectCustomerCheckBox(false);
            setFreeStandingCheckBox(false);
            setSlideInCheckBox(false);
            setCooktopCheckBox(false);
            setClosingDiscussCustomerCheckBox(false);
            setDiscussCustomerAvailabilityCheckBox(false);
            setScheduleProjectCheckBox(false);
            setLowesSurveyExpectationCheckBox(false);
            setProvideYourContactCheckBox(false);
            setPlumbingDisconnectCheckBox(false);
            setPlumbingReconnectCheckBox(false);
            setBacksplashCheckBox(false);
            setEmailText('');
            setContactNameText('');
            setPhoneNumberText('');
            setChipMinimizerCheckBox(false);
            setPlumbingOfferCheckBox(false);
            setPlumbingConnectionsCheckBox(false);
            setPlumbing1120679CheckBox(false);
            setPlumbing1120669CheckBox(false);
            setGranite1120680Checkbox(false);
            setGranite1120686Checkbox(false);
            setGranite1120685Checkbox(false);
            setGranite1120684Checkbox(false);
            setQuartz1120670Checkbox(false);
            setQuartz1120676Checkbox(false);
            setQuartz1120675Checkbox(false);
            setQuartz1120674Checkbox(false);
            setPlumbingNotOfferDisconnectCheckBox(false);
            setPlumbingNotOfferDisconnectInstallerCheckbox(false);
            setPlumbingNotOfferDisconnectCustomerCheckbox(false);
            setPlumbingNotOfferReconnectCheckBox(false);
            setPlumbingNotOfferDisconnectInstallerCheckbox(false);
            setPlumbingNotOfferReconnectCheckBox(false);
            setAppliancesMakeText('');
            setAppliancesModelText('');
            setAppliancesMakeCheckBox(false);
            setAppliancesDropInCheckBox(false);
            setGranite5YearCheckBox(false);
            setGranite10YearCheckBox(false);
            setPlumbingNotOfferReconnectCustomerCheckbox(false);
            setNoteText('');
            setPlumbingNotOfferReconnectInstallerCheckbox(false);
        };

        return (
            <div>
                <div className='main-header'>
                    <h1>Project Manager - Initial Contact Script</h1>
                </div>

                <div className='section-container'>
                    <div className='sub-header-top-line'></div>
                    <div className='sub-header'><span>Greeting & Customer Information</span></div>
                    <div className='section-row'>
                        <label>
                            <input type="checkbox" checked={mayISpeakToCheckBox} onChange={(e) => setMayISpeakTo(e.target.checked)} />
                            “May I speak to (customer name)”
                        </label>
                    </div>
                    <div className='section-row'>
                        <label>
                            <input type="checkbox" checked={introduceYourselfCheckBox} onChange={(e) => setintroduceYourself(e.target.checked)} />
                            Introduce yourself, your company – in partnership with Lowe’s, and that you’re calling about
                            their <b>Lowe’s countertop project.</b>
                        </label>
                    </div>
                    <div className='section-row'>
                        <label>
                            <input type="checkbox" checked={confirmCustomerCheckBox} onChange={(e) => setConfirmCustomer(e.target.checked)} />
                            Confirm customer has 10-15 mins to review <b>countertop project information</b>.
                        </label>
                    </div>
                    <div className='section-row'>
                        <label>
                            <input type="checkbox" checked={lowesSurveyScoreCheckBox} onChange={(e) => setLowesSurveyScoreCheckBox(e.target.checked)} />
                            <b>Lowe’s survey perfect score expectation</b> – “serves as our report card and only scored on a
                            perfect 10.”
                        </label>
                        <div className='section-row-section-hint-italic'>
                            » "Delivering a 10-star countertop experience is our aim, and we're eager to earn your
                            recommendation through our report card. Your feedback is invaluable in helping us
                            achieve a perfect 10 star review."
                        </div>
                    </div>
                    <div className='section-row'>
                        <label>
                            <input type="checkbox" checked={verifyFollowingCheckBox} onChange={(e) => setverifyFollowingCheckBox(e.target.checked)} />
                            <b>Verify the following:</b>
                        </label>
                        <div className='section-row-section-hint'>
                            <span className='floatLeft'>
                                <label >
                                    Job address:
                                    <input
                                        type="text"
                                        style={{ width: "700px", marginLeft: '20px' }}
                                        value={jobAddressText}
                                        onChange={handleJobAddressChange}
                                        placeholder="" />
                                </label>
                            </span>
                        </div>
                        <div className='section-row-section-hint'>
                            <span className='floatLeft'>
                                <span className='floatLeft'>
                                    <label>
                                        Email:
                                        <input
                                            type="text"
                                            style={{ width: "200px", marginLeft: '10px' }}
                                            value={emailText}
                                            onChange={handleEmailText}
                                            placeholder="" />
                                    </label>
                                </span>
                                <span className='floatLeft' style={{ marginLeft: '20px' }}>
                                    <label>
                                        Contact Name:
                                        <input
                                            type="text"
                                            style={{ width: "100px", marginLeft: '10px' }}
                                            value={contactNameText}
                                            onChange={handleContactNameText}
                                            placeholder="" />
                                    </label>
                                </span>
                                <span className='floatLeft' style={{ marginLeft: '20px' }}>
                                    <label>
                                        Number:
                                        <input
                                            type="text"
                                            style={{ width: "100px", marginLeft: '10px' }}
                                            value={phoneNumberText}
                                            onChange={handlePhoneNumberText}
                                            placeholder="" />
                                    </label>
                                </span>

                            </span>
                        </div>

                        <div className='section-row-section-hint'>
                            <span> Preferred method of communication</span>
                            <span style={{ marginLeft: '10px' }}>
                                <label>
                                    <input type="checkbox" checked={methodOfCommunicationEmailCheckBox} onChange={(e) => setMethodOfCommunicationEmailCheckBox(e.target.checked)} />
                                    email
                                </label>
                            </span>
                            <span style={{ marginLeft: '10px' }}>
                                <label>
                                    <input type="checkbox" checked={methodOfCommunicationCallCheckBox} onChange={(e) => setMethodOfCommunicationCallCheckBox(e.target.checked)} />
                                    call
                                </label>
                            </span>
                            <span style={{ marginLeft: '10px' }}>
                                <label>
                                    <input type="checkbox" checked={methodOfCommunicationTextCheckBox} onChange={(e) => setMethodOfCommunicationTextCheckBox(e.target.checked)} />
                                    text
                                </label>
                            </span>
                        </div>
                    </div>
                </div>

                <div className='section-container'>
                    <div className='sub-header-top-line'></div>
                    <div className='sub-header'><span>Cabinetry & Location</span></div>
                    <div className='section-row'>
                        <label>
                            <input type="checkbox" checked={newOrExistingCabinetsCheckBox} onChange={(e) => setNewOrExistingCabinetsCheckBox(e.target.checked)} />
                            <b>New or existing cabinets?</b>
                        </label>
                        <div className='section-row-section-hint'>
                            <label>
                                <input type="checkbox" checked={ifExistingCabinetsCheckBox} onChange={(e) => setIfExistingCabinetsCheckBox(e.target.checked)} />
                                <b>If existing cabinets</b> – who is removing current countertops? If us, what material is being
                                removed? (tile / stone or laminate / solid surface)
                            </label>
                        </div>
                        <div className='section-row-section-hint'>
                            <textarea
                                value={whoRemovedText}
                                onChange={handleWhoRemovedTextChange}
                                placeholder="Enter your text here..."
                                rows={5}
                                cols={40}
                                className='input-fullsize'
                            />
                        </div>
                        <div className='section-row-section-hint'>
                            <label>
                                <input type="checkbox" checked={ifNewCabinetsCheckBox} onChange={(e) => setIfNewCabinetsCheckBox(e.target.checked)} />
                                <b>If new cabinets</b> - Base cabinets must be level, plumb, permanently + securely installed before
                                template
                            </label>
                        </div>
                    </div>
                    <div className='section-row'>
                        <label>
                            <input type="checkbox" checked={specialtyCabinetsAndMirrorsCheckBox} onChange={(e) => setSpecialtyCabinetsAndMirrorsCheckBox(e.target.checked)} />
                            <b>Specialty Cabinet & Mirrors</b>
                        </label>
                        <div className='section-row-section-hint'>
                            » Appliance, garage, tall cabinets, mirrors, mirror clips, etc.
                        </div>
                        <div className='section-row-section-hint'>
                            » These must be removed prior to template / install
                        </div>
                    </div>
                </div>

                <div className='section-container'>
                    <div className='sub-header-top-line'></div>
                    <div className='sub-header'><span>Countertop Details</span></div>
                    <div className='section-row'>
                        <label className='room-or-location-container'>
                            <input type="checkbox" checked={roomOrLocationCheckBox} onChange={(e) => setRoomOrLocationCheckBox(e.target.checked)} />
                            Room/location of their countertop project (i.e. Kitchen, Bathroom, etc.)
                            <span>
                                <input type='text' value={roomOrLocationText} onChange={handleRoomLocationText} className='room-or-location-input' />
                            </span>
                        </label>
                    </div>
                    <div className='section-row'>
                        <label className='room-or-location-container'>
                            <input type="checkbox" checked={colorAndFinishCheckBox} onChange={(e) => setColorAndFinishCheckBox(e.target.checked)} />
                            <b>Color & Finish</b>
                        </label>
                        <div className='section-row-section-hint'>
                            »   If Natural Stone: Slab View (in person or virtual - explain process for each):
                            <label style={{ marginLeft: '20px' }}>
                                <input type="checkbox" checked={ifNaturalStoneYesCheckBox} onChange={(e) => setIfNaturalStoneYesCheckBox(e.target.checked)} />
                                Yes
                            </label>
                            <label style={{ marginLeft: '20px' }}>
                                <input type="checkbox" checked={ifNaturalStoneNoCheckBox} onChange={(e) => setIfNaturalStoneNoCheckBox(e.target.checked)} />
                                No
                            </label>
                        </div>
                        <div className='section-row-section-hint'>
                            »   Edge: <input type='text' value={colorOrFinishEdgeText} onChange={handleColorOrFinishEdgeText} />
                        </div>
                    </div>
                    <div className='section-row'>
                        <div>
                            <label>
                                <input type="checkbox" checked={backsplashCheckBox} onChange={(e) => setBacksplashCheckBox(e.target.checked)} />
                                <b>Backsplash</b>
                            </label>
                            <label style={{ marginLeft: '20px' }}>
                                <input type="checkbox" checked={backsplashSlabCheckBox} onChange={(e) => setBacksplashSlabCheckBox(e.target.checked)} />
                                Slab
                            </label>
                            <label style={{ marginLeft: '20px' }}>
                                <input type="checkbox" checked={backsplashCustomerSuppliedCheckBox} onChange={(e) => setBacksplashCustomerSuppliedCheckBox(e.target.checked)} />
                                Customer Supplied
                            </label>
                        </div>
                        <div className='section-row-section-hint'>
                            »   If Slab - Thickness:
                            <label style={{ marginLeft: '20px' }}>
                                <input type="checkbox" checked={ifSlabThickness3cmCheckBox} onChange={(e) => setIfSlabThickness3cmCheckBox(e.target.checked)} />
                                3cm
                            </label>
                            <label style={{ marginLeft: '20px' }}>
                                <input type="checkbox" checked={ifSlabThickness2cmCheckBox} onChange={(e) => setIfSlabThickness2cmCheckBox(e.target.checked)} />
                                2cm
                            </label>
                        </div>
                    </div>
                    <div className='section-row'>
                        <span className='floatLeft' style={{ marginLeft: '3px' }}>
                            <b> Height</b>
                        </span>
                        <span className='floatLeft' style={{ marginLeft: '16px' }}>
                            <label>
                                <input type="checkbox" checked={standard4CheckBox} onChange={(e) => setStandard4CheckBox(e.target.checked)} />
                                Standard - 4"
                            </label>
                        </span>
                        <span className='floatLeft' style={{ marginLeft: '16px' }}>
                            <label >
                                <input type="checkbox" checked={fullHeightCheckBox} onChange={(e) => setFullHeightCheckBox(e.target.checked)} />
                                Full Height
                            </label>
                        </span>
                        <span className='floatLeft' style={{ marginLeft: '16px' }}>
                            <label >
                                Other:
                                <span style={{ marginLeft: '10px' }}>
                                    <input type='text' value={otherText} onChange={handleOtherText} />
                                </span>
                            </label>
                        </span>
                    </div>
                    <div className='section-row'>
                        <label >
                            <input type="checkbox" checked={extendedOverhangsCheckBox} onChange={(e) => setExtendedOverhangsCheckBox(e.target.checked)} />
                            <b>Extended Overhangs (if applicable):</b>
                        </label>
                        <input type='text' value={extendedOverhangsText} onChange={handleExtendedOverhangsText} style={{ width: '500px' }} />
                    </div>
                    <div className='section-row'>
                        <span>
                            <label>
                                <input type="checkbox" checked={supportCheckBox} onChange={(e) => setSupportCheckBox(e.target.checked)} />
                                <b>Support:</b>
                            </label>
                        </span>
                        <span style={{ marginLeft: '10px' }}>
                            <label>
                                <input type="checkbox" checked={customerSuppliedCheckBox} onChange={(e) => setCustomerSuppliedCheckBox(e.target.checked)} />
                                Customer Supplied
                            </label>
                        </span>
                        <span style={{ marginLeft: '10px' }}>
                            <label>
                                <input type="checkbox" checked={installerProvidedCheckBox} onChange={(e) => setInstallerProvidedCheckBox(e.target.checked)} />
                                Installer Provided
                            </label>
                        </span>
                        <div className='section-row-section-hint'>
                            »   If customer supplied: Installed + level at time of template
                        </div>
                    </div>
                </div>

                <div className='section-container'>
                    <div className='sub-header-top-line'></div>
                    <div className='sub-header'><span>Sink(s)</span></div>
                    <div className='section-row'>
                        <span>
                            <label>
                                <input type="checkbox" checked={suppliedCheckBox} onChange={(e) => setSuppliedCheckBox(e.target.checked)} />
                                <b>Supplied:</b>
                            </label>
                        </span>
                        <span style={{ marginLeft: '10px' }}>
                            <label>
                                <input type="checkbox" checked={sinkInstallerCheckBox} onChange={(e) => setSinkInstallerCheckBox(e.target.checked)} />
                                Installer
                            </label>
                        </span>
                        <span style={{ marginLeft: '10px' }}>
                            <label>
                                <input type="checkbox" checked={customerCheckBox} onChange={(e) => setCustomerCheckBox(e.target.checked)} />
                                Customer
                            </label>
                        </span>
                        <span style={{ marginLeft: '10px' }}>
                            <label>
                                Make:
                                <span style={{ marginLeft: '10px' }}>
                                    <input type='text' value={makeText} onChange={handleMakeText} />
                                </span>
                            </label>
                        </span>
                        <span style={{ marginLeft: '10px' }}>
                            <label>
                                Model:
                                <span style={{ marginLeft: '10px' }}>
                                    <input type='text' value={modelText} onChange={handleModelText} />
                                </span>
                            </label>
                        </span>
                        <div className='section-row-section-hint'>
                            <span >
                                <label>
                                    <input type="checkbox" checked={undermountCheckBox} onChange={(e) => setUndermountCheckBox(e.target.checked)} />
                                    Undermount
                                </label>
                            </span>
                            <span style={{ marginLeft: '10px' }}>
                                <label>
                                    <input type="checkbox" checked={dropInCheckBox} onChange={(e) => setDropInCheckBox(e.target.checked)} />
                                    Drop in
                                </label>
                            </span>
                            <span style={{ marginLeft: '10px' }}>
                                <label>
                                    <input type="checkbox" checked={apronCheckBox} onChange={(e) => setApronCheckBox(e.target.checked)} />
                                    Apron / Farmhouse (Must be Permanently + securely installed \Level + plumb)
                                </label>
                            </span>
                        </div>
                    </div>
                    <div className='section-row'>
                        <span>
                            <label>
                                <input type="checkbox" checked={chipMinimizerCheckBox} onChange={(e) => setChipMinimizerCheckBox(e.target.checked)} />
                                <b>Chip minimizer?</b>
                            </label>
                        </span>
                        <span>
                            <label style={{ marginLeft: '20px' }}>
                                <input type="checkbox" checked={chipMinimizerYesCheckBox} onChange={(e) => setChipMinimizerYesCheckBox(e.target.checked)} />
                                Yes
                            </label>
                        </span>
                        <span>
                            <label style={{ marginLeft: '20px' }}>
                                <input type="checkbox" checked={chipMinimizerNoCheckBox} onChange={(e) => setChipMinimizerNoCheckBox(e.target.checked)} />
                                No
                            </label>
                        </span>
                    </div>
                    <div className='section-row'>
                        <span>
                            <label >
                                <input type="checkbox" checked={customerResponsibilityToRemoveCheckBox} onChange={(e) => setCustomerResponsibilityToRemoveCheckBox(e.target.checked)} />
                                Customer’s responsibility to remove, clean and prep prior to template if re-using existing sink.
                            </label>
                        </span>
                    </div>
                    <div className='section-row'>
                        <b>Customer supplied only - Must be on site at time of template for verification</b>
                    </div>
                </div>

                <div className='section-container'>
                    <div className='sub-header-top-line'></div>
                    <div className='sub-header'><span>Faucet</span></div>
                    <div className='section-row'>
                        <span style={{ float: 'left' }}>
                            <label>
                                <input type="checkbox" checked={faucetMakeCheckBox} onChange={(e) => setFaucetMakeCheckBox(e.target.checked)} />
                                <b>Make:</b>
                            </label>
                            <span style={{ marginLeft: '10px' }}>
                                <input type='text' value={faucetMakeText} onChange={handleFaucetMakeText} style={{ width: '200px' }} />
                            </span>
                        </span>
                        <span>
                            <label>
                                <span style={{ marginLeft: '5px' }}>
                                    <b>Model:</b>
                                </span>
                            </label>
                            <span style={{ marginLeft: '10px' }}>
                                <input type='text' value={faucetModelText} onChange={handleFaucetModelText} style={{ width: '200px' }} />
                            </span>
                        </span>
                    </div>
                    <div className='section-row'>
                        <span style={{ float: 'left' }}>
                            <label>
                                <input type="checkbox" checked={numberOfHoles} onChange={(e) => setNumberOfHoles(e.target.checked)} />
                                <b>Number of holes:</b>
                            </label>
                            <span style={{ marginLeft: '10px' }}>
                                <input type='text' value={numberOfHolesText} onChange={handleNumberOfHolesText} style={{ width: '200px' }} />
                            </span>
                        </span>
                        <div className='section-row-section-hint'>
                            <span>
                                <label>
                                    <input type="checkbox" checked={hotOrColdWaterDispenserCheckbox} onChange={(e) => setHotOrColdWaterDispenserCheckbox(e.target.checked)} />
                                    Hot/Cold Water Dispenser
                                </label>
                            </span>
                            <span style={{ marginLeft: '10px' }}>
                                <label>
                                    <input type="checkbox" checked={soapPumpCheckBox} onChange={(e) => setSoapPumpCheckBox(e.target.checked)} />
                                    Soap Pump
                                </label>
                            </span>
                            <span style={{ marginLeft: '10px' }}>
                                <label>
                                    <input type="checkbox" checked={glassRinserCheckBox} onChange={(e) => setGlassRinserCheckBox(e.target.checked)} />
                                    Glass Rinser
                                </label>
                            </span>
                            <span style={{ marginLeft: '10px' }}>
                                <label>
                                    <input type="checkbox" checked={airSwitchCheckBox} onChange={(e) => setAirSwitchCheckBox(e.target.checked)} />
                                    Air Switch/Gap
                                </label>
                            </span>
                        </div>
                        <div className='section-row-section-hint'>
                            » Required in order to schedule template
                        </div>
                    </div>
                    <div className='section-row'>
                        <label >
                            <b>Must be on site at time of template for verification.</b>
                        </label>
                    </div>

                </div>

                <div className='section-container'>
                    <div className='sub-header-top-line'></div>
                    <div className='sub-header'><span>Plumbing</span></div>
                    <div className='section-row'>
                        <label>
                            For plumbing service offered by CFI through Lowe’s SKUs CFI (Quartz & Granite only):
                        </label>
                    </div>
                    <div className='section-row'>
                        <span>
                            <label>
                                <input type="checkbox" checked={plumbingOfferCheckBox} onChange={(e) => setPlumbingOfferCheckBox(e.target.checked)} />
                                “We offer plumbing services to make your countertop installation a seamless process. We
                                handle both your countertop installation and plumbing, so you don’t need to coordinate with
                                a separate plumber. Our team ensures everything is perfectly timed and installed, reducing
                                any risk of delays. Our plumbing service is held to the same standards, backed by our certified
                                plumbers.”
                            </label>
                        </span>
                    </div>
                    <div className='section-row'>
                        <span>
                            <label>
                                <input type="checkbox" checked={plumbingConnectionsCheckBox} onChange={(e) => setPlumbingConnectionsCheckBox(e.target.checked)} />
                                “Every countertop installation requires a plumbing disconnect and reconnect, would you like
                                to add these services to your countertop project? We can go ahead and add them so you will
                                receive a quote after the template appointment.”
                            </label>
                        </span>
                    </div>

                    <div className='section-row'>
                        <span>
                            <label>
                                <input type="checkbox" checked={plumbingDisconnectCheckBox} onChange={(e) => setPlumbingDisconnectCheckBox(e.target.checked)} />
                                <b>Plumbing disconnect:</b>
                            </label>
                        </span>
                        <span style={{ marginLeft: '10px' }}>
                            <label>
                                <input type="checkbox" checked={plumbingDisconnectInstallerCheckBox} onChange={(e) => setPlumbingDisconnectInstallerCheckBox(e.target.checked)} />
                                Installer
                            </label>
                        </span>
                        <span style={{ marginLeft: '10px' }}>
                            <label>
                                <input type="checkbox" checked={plumbingCustomerCheckBox} onChange={(e) => setPlumbingCustomerCheckBox(e.target.checked)} />
                                Customer
                            </label>
                        </span>
                        <div className='section-row-section-hint'>
                            *Select the applicable option below if Installer is selected:
                        </div>
                        <div className='section-row-section-hint'>
                            <span className='floatLeft'>
                                <label>
                                    <input type="checkbox" checked={plumbing1120679CheckBox} onChange={(e) => setPlumbing1120679CheckBox(e.target.checked)} />
                                    1120679: Granite Plumbing Disconnect
                                </label>
                            </span>
                            <span style={{ marginLeft: '20px' }}>
                                <label>
                                    <input type="checkbox" checked={plumbing1120669CheckBox} onChange={(e) => setPlumbing1120669CheckBox(e.target.checked)} />
                                    1120669: Quartz Plumbing Disconnect
                                </label>
                            </span>
                        </div>
                    </div>
                    <div className='section-row'>
                        <span>
                            <label>
                                <input type="checkbox" checked={plumbingReconnectCheckBox} onChange={(e) => setPlumbingReconnectCheckBox(e.target.checked)} />
                                <b>Plumbing reconnect:</b>
                            </label>
                        </span>
                        <span style={{ marginLeft: '10px' }}>
                            <label>
                                <input type="checkbox" checked={plumbingReconnectCustomerCheckBox} onChange={(e) => setPlumbingReconnectCustomerCheckBox(e.target.checked)} />
                                Customer
                            </label>
                        </span>
                        <span style={{ marginLeft: '10px' }}>
                            <label>
                                <input type="checkbox" checked={plumbingReconnectInstallerCheckBox} onChange={(e) => setPlumbingReconnectInstallerCheckBox(e.target.checked)} />
                                Installer*
                            </label>
                        </span>
                        <div className='section-row-section-hint'>
                            *Select the applicable option below if Installer is selected:
                        </div>
                        <div className="section-row-section-hint">
                            <label>
                                <div >
                                    <b>GRANITE:</b>
                                </div>
                            </label>
                        </div>
                        <div className="section-row-section-hint">
                            <label>
                                <input type="CheckBox" checked={granite1120680Checkbox} onChange={(e) => setGranite1120680Checkbox(e.target.checked)} />
                                1120680: Granite Plumbing: Plumbing Connection of New Main Faucet & Drains to New Sink
                            </label>
                        </div>
                        <div className="section-row-section-hint">
                            <label >
                                <input type="CheckBox" checked={granite1120686Checkbox} onChange={(e) => setGranite1120686Checkbox(e.target.checked)} />
                                1120686: Granite Plumbing: Connect New Faucet Shutoff Valves (includes hot & cold shutoff valves)
                            </label>
                        </div>
                        <div className="section-row-section-hint">
                            <label >
                                <input type="CheckBox" checked={granite1120685Checkbox} onChange={(e) => setGranite1120685Checkbox(e.target.checked)} />
                                1120685: Granite Plumbing: Install New/Existing Dishwasher & Plumbing Connection
                            </label>
                        </div>

                        <div className="section-row-section-hint">
                            <label >
                                <input type="CheckBox" checked={granite1120684Checkbox} onChange={(e) => setGranite1120684Checkbox(e.target.checked)} />
                                1120684: Granite Plumbing: Install New/Existing Garbage Disposal & Plumbing Connection
                            </label>
                        </div>

                        <div className="section-row-section-hint">
                            <label>
                                <div  >
                                    <b>QUARTZ:</b>
                                </div>
                            </label>
                        </div>

                        <div className="section-row-section-hint">
                            <label>
                                <input type="CheckBox" checked={quartz1120670Checkbox} onChange={(e) => setQuartz1120670Checkbox(e.target.checked)} />
                                1120670: Quartz Plumbing: Plumbing Connection of New Main Faucet & Drains to New Sink
                            </label>
                        </div>

                        <div className="section-row-section-hint">
                            <label>
                                <input type="CheckBox" checked={quartz1120676Checkbox} onChange={(e) => setQuartz1120676Checkbox(e.target.checked)} />
                                1120676: Quartz Plumbing: Connect New Faucet Shutoff Valves (includes hot & cold shutoff valves)
                            </label>
                        </div>
                        <div className="section-row-section-hint">
                            <label>
                                <input type="CheckBox" checked={quartz1120675Checkbox} onChange={(e) => setQuartz1120675Checkbox(e.target.checked)} />
                                1120675: Quartz Plumbing: Install New/Existing Dishwasher & Plumbing Connection
                            </label>
                        </div>
                        <div className="section-row-section-hint">
                            <label>
                                <input type="CheckBox" checked={quartz1120674Checkbox} onChange={(e) => setQuartz1120674Checkbox(e.target.checked)} />
                                1120674: Quartz Plumbing: Install New/Existing Garbage Disposal & Plumbing Connection
                            </label>
                        </div>
                    </div>
                    <div className='section-row'>
                        <label>
                            <b>Plumbing services NOT offered through Lowe’s SKUs:</b>
                        </label>
                    </div>
                    <div className='section-row'>
                        <span className='floatLeft'>
                            <label>
                                <input type="CheckBox" checked={plumbingNotOfferDisconnectCheckBox} onChange={(e) => setPlumbingNotOfferDisconnectCheckBox(e.target.checked)} />
                                <b>Plumbing Disconnect:</b>
                            </label>
                        </span>
                        <span className='floatLeft' style={{ marginLeft: '20px' }}>
                            <label>
                                <input type="CheckBox" style={{ marginLeft: '10px' }} checked={plumbingNotOfferDisconnectInstallerCheckbox} onChange={(e) => setPlumbingNotOfferDisconnectInstallerCheckbox(e.target.checked)} />
                                Installer
                            </label>
                        </span>
                        <span className='floatLeft' style={{ marginLeft: '20px' }}>
                            <label>
                                <input type="CheckBox" style={{ marginLeft: '10px' }} checked={plumbingNotOfferDisconnectCustomerCheckbox} onChange={(e) => setPlumbingNotOfferDisconnectCustomerCheckbox(e.target.checked)} />
                                Customer
                            </label>
                        </span>
                    </div>

                    <div className='section-row'>
                        <span className='floatLeft '>
                            <label>
                                <input type="CheckBox" checked={plumbingNotOfferReconnectCheckBox} onChange={(e) => setPlumbingNotOfferReconnectCheckBox(e.target.checked)} />
                                <b>Plumbing Reconnect:</b>
                            </label>
                        </span>
                        <span className='floatLeft' style={{ marginLeft: '20px' }}>
                            <label>
                                <input type="CheckBox" style={{ marginLeft: '10px' }} checked={plumbingNotOfferReconnectInstallerCheckbox} onChange={(e) => setPlumbingNotOfferReconnectInstallerCheckbox(e.target.checked)} />
                                Installer (new fixtures only)
                            </label>
                        </span>
                        <span className='floatLeft' style={{ marginLeft: '20px' }}>
                            <label>
                                <input type="CheckBox" style={{ marginLeft: '10px' }} checked={plumbingNotOfferReconnectCustomerCheckbox} onChange={(e) => setPlumbingNotOfferReconnectCustomerCheckbox(e.target.checked)} />
                                Customer
                            </label>
                        </span>
                    </div>

                </div>

                <div className='section-container'>
                    <div className='sub-header-top-line'></div>
                    <div className='sub-header'><span style={{ float: 'left' }}>Appliances</span>
                    </div>
                    <div className='section-row'>
                        Cooking Appliances must be onsite at time of template
                    </div>
                    <div className='section-row'>
                        <span>
                            <label>
                                <input type="CheckBox" style={{ marginLeft: '15px' }} checked={appliancesMakeCheckBox} onChange={(e) => setAppliancesMakeCheckBox(e.target.checked)} />
                                Make:
                            </label>
                        </span>
                        <span>
                            <input
                                type="text"
                                style={{ width: "200px", marginLeft: '15px' }}
                                value={appliancesMakeText}
                                onChange={handleAppliancesMakeText}
                                placeholder="" />
                        </span>
                        <span style={{ marginLeft: '35px' }}>
                            <label>
                                Model:
                            </label>
                        </span>
                        <span>
                            <input
                                type="text"
                                style={{ width: "200px", marginLeft: '15px' }}
                                value={appliancesModelText}
                                onChange={handleAppliancesModelText}
                                placeholder="" />
                        </span>

                        <div className='section-row-section-hint'>
                            <span>
                                <label>
                                    <input type="CheckBox" style={{ marginLeft: '15px' }} checked={freeStandingCheckBox} onChange={(e) => setFreeStandingCheckBox(e.target.checked)} />
                                    Free standing
                                </label>
                            </span>
                            <span>
                                <label>
                                    <input type="CheckBox" style={{ marginLeft: '15px' }} checked={slideInCheckBox} onChange={(e) => setSlideInCheckBox(e.target.checked)} />
                                    Slide-in
                                </label>
                            </span>
                            <span>
                                <label>
                                    <input type="CheckBox" style={{ marginLeft: '15px' }} checked={appliancesDropInCheckBox} onChange={(e) => setAppliancesDropInCheckBox(e.target.checked)} />
                                    Drop-In
                                </label>
                            </span>
                            <span>
                                <label>
                                    <input type="CheckBox" style={{ marginLeft: '15px' }} checked={cooktopCheckBox} onChange={(e) => setCooktopCheckBox(e.target.checked)} />
                                    Cooktop
                                </label>
                            </span>
                        </div>
                    </div>
                </div>


                <div className='section-container'>
                    <div className='sub-header-top-line'></div>
                    <div className='sub-header'><span style={{ float: 'left' }}>Granite Gold</span>
                    </div>
                    <div className='section-row'>
                        Peace of Mind Protection Accidental Plan that covers
                        chips, etches, household stains, seams, hardwater marks,
                        scratches, and caulking which are items not covered on
                        any included material or installation warranties. Offer to
                        send more information
                        <div className='granite-gold-price-container'>
                            <label>
                                <input type="CheckBox" style={{ marginLeft: '15px' }} checked={granite5YearCheckBox} onChange={(e) => setGranite5YearCheckBox(e.target.checked)} />
                                <b>5 year</b> - $299 retail
                            </label>
                        </div>
                        <div className='granite-gold-price-container'>
                            <label>
                                <input type="CheckBox" style={{ marginLeft: '15px' }} checked={granite10YearCheckBox} onChange={(e) => setGranite10YearCheckBox(e.target.checked)} />
                                <b>10 year</b> - $399 retail
                            </label>
                        </div>
                    </div>
                </div>

                <div className='section-container'>
                    <div className='sub-header-top-line'></div>
                    <div className='sub-header'><span>Closing & Next Steps</span></div>
                    <div className='section-row'>
                        <label>
                            <input type="checkbox" checked={closingDiscussCustomerCheckBox} onChange={(e) => setClosingDiscussCustomerCheckBox(e.target.checked)} />
                            Discuss customer’s time frame of project for scheduling template/installation,<b> setting
                                expectations of countertop project lead times</b>
                        </label>
                    </div>
                    <div className='section-row'>
                        <label>
                            <input type="checkbox" checked={discussCustomerAvailabilityCheckBox} onChange={(e) => setDiscussCustomerAvailabilityCheckBox(e.target.checked)} />
                            Discuss customer availability - Decision maker MUST be present
                        </label>
                    </div>
                    <div className='section-row'>
                        <label>
                            <input type="checkbox" checked={scheduleProjectCheckBox} onChange={(e) => setScheduleProjectCheckBox(e.target.checked)} />
                            Schedule project – if applicable
                        </label>
                        <div className='section-row-section-hint'>
                            » Review the Prep for Template Checklist and mention that they will receive a copy from
                            Lowe’s on the template appointment confirmation email
                        </div>
                        <div className='section-row-section-hint'>
                            » Mention the length of the template appointment
                        </div>
                    </div>
                    <div className='section-row'>
                        <label>
                            <input type="checkbox" checked={lowesSurveyExpectationCheckBox} onChange={(e) => setLowesSurveyExpectationCheckBox(e.target.checked)} />
                            <b>Lowe’s survey perfect score expectation</b> – “serves as our report card and only scored on a
                            perfect 10.”
                        </label>
                        <div className='section-row-section-hint-italic'>
                            » "Delivering a 10-star countertop experience is our aim, and we're eager to earn your
                            recommendation through our report card. Your feedback is invaluable in helping us achieve
                            a perfect 10 star review. We always strive for excellence, so if there's any reason why we
                            haven't met your expectations on your countertop project, please contact me directly."
                        </div>
                    </div>
                    <div className='section-row'>
                        <label>
                            <input type="checkbox" checked={provideYourContactCheckBox} onChange={(e) => setProvideYourContactCheckBox(e.target.checked)} />
                            Provide your direct contact email and phone number                    </label>
                        <div className='section-row-section-hint'>
                            » “Thank you (their name) for your purchase and taking the time to talk with me today. We
                            at (company name) look forward to providing you with a perfect service and installing the
                            countertop of your dreams.”                    </div>
                    </div>
                    <div className='section-row'>
                        Notes:
                        <textarea
                            className='input-fullsize-large-height'
                            value={noteText}
                            onChange={handleNoteText}
                            placeholder="Note"
                            rows={5}
                            cols={40}
                        />
                    </div>
                </div>

                <div className='button-container'>
                    <Button
                        text="Reset"
                        className='reset-button'
                        type="danger"
                        onClick={(e) => {
                            handleReset();
                        }} >
                    </Button>
                    <Button
                        text="Save Changes"
                        className="save-button"
                        onClick={(e) => {
                            saveInitialContactScriptForm.mutate();
                        }} >
                    </Button>
                </div>
            </div>
        );
    };

export default InitialContactScriptForm;
